/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import classnames from "classnames";
import JobDescription from "./components/JobDescription";
import {
    GetProposalDetail,
    GetFreelancerDetail,
    GetFreelancerReview,
    GetSubmittalDetail,
    GetTalentProfile,
    UpdateNotes,
    GetNotes,
} from "../../../services/freelancer";
import { Failed } from "../../../assets/images";
import { convertDate } from "../../../util/dateTime";
import { convertFromRaw } from "draft-js";
import { generateJsonFromHTML } from "../../../util/generateHTMLfromJSON";
import Label from "../../../components/label";
import Certification from "./components/Certification";
import Courses from "./components/Courses";
import Education from "./components/Education";
import AboutMe from "./components/AboutMe";
import RolesAndSkills from "./components/RolesAndSkills";
import WorkExperience from "./components/WorkExperience";
import LanguagesSection from "./components/Languages";
import TestimonialsAndReview from "./components/TestimonialAndReview";
import UserDetails from "./components/UserDetail";
import UserJobs from "./components/Jobs";
import FormTextarea from "../../../components/formTextarea/FormTextarea";
import Button from "../../../components/button";
import ProposalHeader from "./components/ProposalHeader";
import PortfolioSection from "../../Dashboard/Components/Portfolio";
import AIExplanationBox from "./components/AIExplanationBox";
import IndustryExperience from "./components/IndustryExperience";
import ProposalDescription from "./components/ProposalDescription";
import ProjectExperience from "./components/ProjectExperience";
import Pricing from "./components/Pricing";
import Samples from "./components/Samples";
import "./index.scss";

const FreelanceDetail = ({
    instrId,
    handleAcceptClick,
    projectId,
    handleInterviewClick,
    rejectTalent,
    tab,
    isFavorite,
    cancelInterview,
    removeFromRejected,
    talentDetails,
    viewAllTalentJobs,
    fromAccepted,
    refreshList,
    completed,
    fromTalent,
    client,
    preview,
    talentPool = false,
    setTalentFavorite,
    showAIExplanation = false,
}) => {
    const [proposalData, setProposalData] = useState();
    const [freelancer, setFreelancer] = useState({
        portfolioCourses: [],
        portfolioItems: [],
        portfolioLinks: [],
        educations: [],
        workExperiences: [],
        certifications: [],
        profileRoles: [],
        industryExperiences: [],
        languages: [],
    });
    const params = useParams();
    const [review, setReview] = useState();
    const [apiError, setApiError] = useState(false);
    const [notes, setNotes] = useState("");
    const [notesSaved, setNotesSaved] = useState(false);
    const [lastUpdated, setLastUpdated] = useState(null);
    const [showProposalDescription, setShowProposalDescription] =
        useState(null);
    const history = useHistory();
    const queryString = history.location.search;
    const searchParams = new URLSearchParams(queryString);
    const lowerCaseParams = new URLSearchParams(
        Array.from(searchParams, ([key, value]) => [key.toLowerCase(), value])
    );
    const instrIDParam = instrId || parseInt(lowerCaseParams.get("instrid"));
    const projectIDParam = projectId || lowerCaseParams.get("project_id");
    const hash = params.hash || lowerCaseParams.get("hash");
    const componentRef = React.createRef();

    useEffect(() => {
        if (proposalData) {
            const contentState = generateJsonFromHTML(
                proposalData?.proposalDescription
            ).getCurrentContent();
            const plainText = contentState.getPlainText();
            setShowProposalDescription(plainText.trim().length > 0);
        }
    }, [proposalData]);

    useEffect(() => {
        if (
            (projectIDParam &&
                hash &&
                instrIDParam &&
                history.location.pathname === "/preview") ||
            preview
        ) {
            fetchPreviewDetails();
        } else if (history.location.pathname === "/preview" || preview) {
            setApiError(true);
        } else if (tab === "Client") {
            fetchTalentProfile();
            getNotes();
        } else {
            fetch();
            getNotes();
        }
    }, []);

    const fetchPreviewDetails = () => {
        const params = {
            projectID: projectIDParam,
            instrID: instrIDParam,
            hash: hash,
        };
        GetSubmittalDetail(params)
            .then((res) => {
                setFreelancer(res.data.slicedTrainerProfile);
                setProposalData(res.data.talentProjectDetails);
                //setReview(res.data.talentFeedback) // 01/26/2024 Commented out by Mtarga, reviews are not enabled yet
            })
            .catch((err) => {
                setApiError(true);
            });
    };
    const fetch = () => {
        const param = {
            projectID: projectIDParam,
            instrID: instrIDParam,
        };
        GetFreelancerDetail(param).then((response) => {
            setFreelancer({
                ...response.data,
                testimonials: response.data?.testimonials?.filter((res) => {
                    if (res.isResponsePublic) {
                        return res;
                    }
                }),
            });
        });
        GetProposalDetail(param).then((response) => {
            setProposalData(response.data);
        });
        GetFreelancerReview(param).then((response) => {
            setReview(response.data);
        });
    };

    const fetchTalentProfile = () => {
        GetTalentProfile(instrIDParam).then((res) => {
            setFreelancer(res.data);
        });
        GetFreelancerReview({ instrID: instrIDParam }).then((response) => {
            setReview(response.data);
        });
    };

    const getNotes = () => {
        const params = {
            projectId: parseInt(projectIDParam) || null,
            instrId: instrIDParam,
        };
        GetNotes(params).then((res) => {
            setNotes(res.data?.notes);
            setLastUpdated(res.data?.notesDateUpdated);
        });
    };

    const saveNotes = () => {
        const payload = {
            instrId: instrIDParam,
            note: notes,
            projectId: parseInt(projectIDParam) || null,
        };
        UpdateNotes(payload).then(() => {
            setNotesSaved(true);
            setLastUpdated(new Date());
        });
    };

    return (
        <div>
            {apiError ? (
                <>
                    <div className="forbiddenWrapper">
                        <div className="forbiddenBox">
                            <div>
                                <img src={Failed} className="mb-3" alt="" />{" "}
                                <Label
                                    className="smallHeaderTextSmallFont"
                                    label="Error"
                                ></Label>
                                <div className="forbiddenText">
                                    Invalid Credentials Provided
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div ref={componentRef}>
                    <JobDescription proposalData={proposalData} tab={tab} />
                    <div className="d-flex justify-content-center pb-3">
                        <div
                            className={classnames(
                                client && !fromTalent
                                    ? "clientWrap"
                                    : "userDetailsWrap"
                            )}
                        >
                            <div
                                className={
                                    !fromTalent || client
                                        ? "firstContainerWidth"
                                        : "w-100"
                                }
                            >
                                <div
                                    className={
                                        fromTalent && !client
                                            ? "wrapperProposalFreelancer ml-0"
                                            : "wrapperProposalFreelancer"
                                    }
                                >
                                    {!fromTalent && (
                                        <>
                                            <ProposalHeader
                                                proposalData={proposalData}
                                                instrID={instrIDParam}
                                                projectID={projectIDParam}
                                                handleAcceptClick={
                                                    handleAcceptClick
                                                }
                                                handleInterviewClick={
                                                    handleInterviewClick
                                                }
                                                rejectTalent={rejectTalent}
                                                tab={tab}
                                                isFavorite={isFavorite}
                                                cancelInterview={
                                                    cancelInterview
                                                }
                                                removeFromRejected={
                                                    removeFromRejected
                                                }
                                                hideOptions={projectIDParam}
                                                refreshList={refreshList}
                                                completed={completed}
                                                client={client}
                                            />
                                            <div className="border-top freelanceSep" />
                                        </>
                                    )}
                                    <UserDetails
                                        componentRef={componentRef}
                                        proposalData={proposalData}
                                        myInformation={
                                            freelancer?.myInformation
                                        }
                                        projectID={projectIDParam}
                                        instrID={instrIDParam}
                                        handleAcceptClick={handleAcceptClick}
                                        handleInterviewClick={
                                            handleInterviewClick
                                        }
                                        rejectTalent={rejectTalent}
                                        refreshList={refreshList}
                                        tab={tab}
                                        isFavorite={isFavorite}
                                        setTalentFavorite={setTalentFavorite}
                                        cancelInterview={cancelInterview}
                                        removeFromRejected={removeFromRejected}
                                        hideOptions={projectIDParam}
                                        fromAccepted={fromAccepted}
                                        completed={completed}
                                        fromTalent={fromTalent}
                                        client={client}
                                        aboutMe={freelancer?.aboutMe}
                                        headline={freelancer?.headline}
                                        instrCompanyLogos={
                                            freelancer?.instrCompanyLogos
                                        }
                                        companyInfo={freelancer.companyInfo}
                                        talentPool={talentPool}
                                    />
                                </div>
                                <div className="freelanceSecondWrapper">
                                    {(!fromTalent || client) && (
                                        <>
                                            <div className="freelancerModalComponentWrap pt-3 mobileView">
                                                <div className="font19Black boldFont">
                                                    Your Notes
                                                </div>
                                                <div className="font14Grey">
                                                    This section is only visible
                                                    to you
                                                </div>
                                                <FormTextarea
                                                    rows={10}
                                                    name="notes"
                                                    label=""
                                                    onChange={(e) => {
                                                        setNotesSaved(false);
                                                        setNotes(
                                                            e.target.value
                                                        );
                                                    }}
                                                    containerStyle={{
                                                        marginBottom: 0,
                                                    }}
                                                    value={notes}
                                                    placeholder="Write your notes about the candidate here."
                                                />
                                                <div className="font14Grey mt-2">
                                                    Last Updated:{" "}
                                                    {convertDate(lastUpdated)}
                                                </div>
                                                <Button
                                                    label={
                                                        notesSaved
                                                            ? "Notes Updated"
                                                            : `Save`
                                                    }
                                                    className="btn-blue w-100 mt-3 mb-3"
                                                    onClick={() => saveNotes()}
                                                    disabled={notesSaved}
                                                />
                                            </div>
                                        </>
                                    )}

                                    {showAIExplanation &&
                                        instrIDParam &&
                                        projectIDParam && (
                                            <AIExplanationBox
                                                instrId={instrIDParam}
                                                projectId={projectIDParam}
                                            />
                                        )}

                                    {talentDetails?.noOfJobs > 0 && (
                                        <>
                                            <UserJobs
                                                data={talentDetails}
                                                viewAllTalentJobs={
                                                    viewAllTalentJobs
                                                }
                                                fromTalent={fromTalent}
                                                client={client}
                                            />
                                        </>
                                    )}

                                    {showProposalDescription === true &&
                                        !fromTalent &&
                                        !client && (
                                            <ProposalDescription
                                                fromTalent={fromTalent}
                                                client={client}
                                                proposalData={proposalData}
                                            />
                                        )}

                                    {proposalData?.rateType &&
                                        !fromTalent &&
                                        !client && (
                                            <Pricing
                                                rateType={
                                                    proposalData?.rateType
                                                }
                                                ratePrice={
                                                    proposalData?.ratePrice
                                                }
                                                ratePriceComment={
                                                    proposalData?.ratePriceComment
                                                }
                                            />
                                        )}

                                    {freelancer?.aboutMe && !client && (
                                        <AboutMe
                                            aboutMe={freelancer?.aboutMe}
                                            fromTalent={fromTalent}
                                            client={client}
                                        />
                                    )}

                                    {freelancer?.projectExperiences?.length >
                                        0 &&
                                        !fromTalent &&
                                        !client && (
                                            <ProjectExperience
                                                projectExperienceData={
                                                    freelancer.projectExperiences
                                                }
                                            />
                                        )}

                                    {[
                                        ...(proposalData?.supportingDocuments ?? []),
                                        ...(proposalData?.portfolioCourses ?? []),
                                        ...(proposalData?.portfolioItems ?? []),
                                        ...(proposalData?.portfolioLinks ?? []),
                                    ].length > 0 &&
                                        !fromTalent &&
                                        !client && (
                                            <Samples
                                                proposalData={proposalData}
                                                instrId={instrIDParam}
                                                projectId={projectIDParam}
                                            />
                                        )}

                                    {freelancer?.testimonials?.length > 0 && (
                                        <TestimonialsAndReview
                                            review={[]}
                                            fromTalent={fromTalent}
                                            testimonials={
                                                freelancer?.testimonials
                                            }
                                            client={client}
                                            instrId={instrIDParam}
                                        />
                                    )}

                                    {freelancer?.profileRoles.length > 0 && (
                                        <RolesAndSkills
                                            profileRoles={
                                                freelancer?.profileRoles
                                            }
                                            fromTalent={fromTalent}
                                            client={client}
                                        />
                                    )}

                                    {freelancer?.industryExperiences.length >
                                        0 && (
                                        <IndustryExperience
                                            fromTalent={fromTalent}
                                            client={client}
                                            industryExperiences={
                                                freelancer?.industryExperiences
                                            }
                                        />
                                    )}

                                    {freelancer?.languages.length > 0 && (
                                        <LanguagesSection
                                            languages={freelancer?.languages}
                                            fromTalent={fromTalent}
                                            client={client}
                                        />
                                    )}

                                    {[
                                        ...freelancer?.portfolioCourses,
                                        ...freelancer?.portfolioLinks,
                                        ...freelancer?.portfolioItems,
                                    ].length > 0 && (
                                        <div
                                            className={
                                                tab === "Client"
                                                    ? "pl-3"
                                                    : " pl-0"
                                            }
                                        >
                                            <PortfolioSection
                                                edit={false}
                                                courses={[]}
                                                linksAndVideos={
                                                    freelancer?.portfolioLinks
                                                }
                                                portfolioItems={
                                                    freelancer?.portfolioItems
                                                }
                                                setRefresh={() => {}}
                                                fromFreelanceModal={true}
                                                fromTalent={fromTalent}
                                                instrId={instrIDParam}
                                                client={client}
                                                projectId={projectIDParam}
                                                preview={preview}
                                                tab={tab}
                                            />
                                        </div>
                                    )}

                                    {freelancer?.portfolioCourses?.length >
                                        0 && (
                                        <Courses
                                            courses={
                                                freelancer?.portfolioCourses
                                            }
                                            fromTalent={fromTalent}
                                            instrId={instrIDParam}
                                            client={client}
                                            preview={preview}
                                        />
                                    )}

                                    {freelancer?.certifications?.length > 0 && (
                                        <Certification
                                            Certifications={
                                                freelancer?.certifications
                                            }
                                            fromTalent={fromTalent}
                                            client={client}
                                        />
                                    )}

                                    {freelancer.companyInfo?.isAgency ? (
                                        ""
                                    ) : (
                                        <>
                                            {freelancer?.workExperiences
                                                ?.length > 0 && (
                                                <WorkExperience
                                                    workExperience={
                                                        freelancer?.workExperiences
                                                    }
                                                    fromTalent={fromTalent}
                                                    client={client}
                                                />
                                            )}
                                            {freelancer?.educations?.length >
                                                0 && (
                                                <Education
                                                    Education={
                                                        freelancer?.educations
                                                    }
                                                    fromTalent={fromTalent}
                                                    client={client}
                                                />
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="notesWrap">
                                {!preview && (!fromTalent || client) && (
                                    <div className=" desktopView">
                                        <div className="font19Black boldFont">
                                            Your Notes
                                        </div>
                                        <div className="font14Grey">
                                            This section is only visible to you
                                        </div>
                                        <FormTextarea
                                            rows={15}
                                            name="notes"
                                            label=""
                                            onChange={(e) => {
                                                setNotesSaved(false);
                                                setNotes(e.target.value);
                                            }}
                                            containerStyle={{ marginBottom: 0 }}
                                            value={notes}
                                            placeholder="Write your notes about the candidate here."
                                        />
                                        <div className="font14Grey mt-2">
                                            Last Updated:{" "}
                                            {convertDate(lastUpdated)}
                                        </div>
                                        <Button
                                            label={
                                                notesSaved
                                                    ? "Notes Updated"
                                                    : `Save`
                                            }
                                            className="btn-blue w-100 mt-3 mb-3"
                                            onClick={() => saveNotes()}
                                            disabled={notesSaved}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FreelanceDetail;
